export default "__VITE_ASSET__Dhu5rG6o__"